import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ResearchView from '../views/ResearchView.vue'
import CasesView from '../views/CasesView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    props: (route) => ({ lang: route.query.lang })
  },
  {
    path: '/research',
    name: 'research',
    component: ResearchView,
    props: (route) => ({ lang: route.query.lang })
  },
  {
    path: '/cases',
    name: 'cases',
    component: CasesView,
    props: (route) => ({ lang: route.query.lang })
  },
]

const router = new VueRouter({
  mode: 'history',  // 使用 history 模式
  routes
})

export default router